import styled, { useTheme } from 'styled-components';

import Icon from '../../components/Icon';
import Box from '../../components/layout/Box';

const StyledItemTitle = styled(Box)`
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.whiteColor};
  flex-grow: 1;
  align-items: center;
`;

const StyledContainer = styled(Box)`
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 4px;
  flex-shrink: 1;
  flex-grow: 1;
  cursor: pointer;
  container-name: sidebar;
  transition: 0.3s;

  &:hover {
    background-color: #174fbf;
    transition: 0.3s;
  }
`;

const StyledIconContainer = styled(Box)`
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Item = ({ onClick, title, icon, isOpen }) => {
  const theme = useTheme();

  return (
    <StyledContainer onClick={onClick}>
      <StyledIconContainer>
        <Icon name={icon} color={theme.colors.whiteColor} />
      </StyledIconContainer>
      {isOpen && <StyledItemTitle>{title}</StyledItemTitle>}
    </StyledContainer>
  );
};

export default Item;
